import React from 'react';
import PropTypes from 'prop-types';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, FormControlLabel, FormGroup, Typography} from '@material-ui/core';
import {EfeBulletList, EfeButtonPrimary, EfeCheckbox, EfeErrorMsg} from 'components';
import {Utils} from 'commons';
import {DocumentServices} from 'services';
import {InferPropTypes} from 'commons/types/Types';
import {Bullet, TermsConditions} from 'commons/models';
import {BottomContent, MainContent} from 'layouts/commons';
import {data} from 'commons/defaults/terms-conditions-data';
import {useSpinner} from 'hooks';
import {useSnackbar} from 'notistack';
import {Messages, SnackbarVariants} from 'commons/constants';

InnerFormTerms.propTypes = {
    handleReturn: PropTypes.func.isRequired,
};

function InnerFormTerms(
    props: InferPropTypes<typeof InnerFormTerms.propTypes & FormikProps<TermsConditions>>
) {
    const {handleChange, values, isSubmitting, handleReturn, errors} = props;

    const {enqueueSnackbar} = useSnackbar();

    const bullets: Array<Bullet> = data;
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    async function handleDownload(doc: string) {
        try {
            setIsLoading(true);
            const response = await DocumentServices.getDocument(doc);
            Utils.functions.downloadDocs(response, `${doc}.pdf`);
            enqueueSnackbar(Messages.FILE_DOWNLOAD_OK, {
                variant: SnackbarVariants.SUCCESS,
            });
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    }

    /* eslint-disable react/jsx-handler-names */
    return (
        <div className='InnerFormTerms'>
            <Form noValidate>
                <MainContent>
                    {useSpinner(isLoading)}
                    <Box>
                        <Typography variant='h2'>{'Antes de comenzar'}</Typography>
                    </Box>
                    <EfeBulletList bullets={bullets} handleHeaderAction={handleDownload} />
                    <Box mt={16}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <EfeCheckbox
                                        name='terms'
                                        id='terms'
                                        onChange={handleChange}
                                        checked={values.terms}
                                    />
                                }
                                label={
                                    'He le\u00eddo y estoy de acuerdo con los t\u00e9rminos y condiciones de Uso de la Plataforma y de la Aplicaci\u00F3n, as\u00ed como el Aviso de Privacidad.'
                                }
                            />
                            {errors.terms && <EfeErrorMsg message={errors.terms} />}
                            <FormControlLabel
                                control={
                                    <EfeCheckbox
                                        name='access'
                                        id='access'
                                        onChange={handleChange}
                                        checked={values.access}
                                    />
                                }
                                label={
                                    'Autorizo el uso de mis datos personales con fines de consulta y validaci\u00f3n.'
                                }
                            />
                            {errors.access && <EfeErrorMsg message={errors.access} />}
                        </FormGroup>
                    </Box>
                </MainContent>
                <BottomContent>
                    <Box width={320} mr={16}>
                        <EfeButtonPrimary
                            fullWidth
                            type='submit'
                            onClick={handleReturn}
                            variant='outlined'>
                            {'Volver'}
                        </EfeButtonPrimary>
                    </Box>
                    <Box width={320}>
                        <EfeButtonPrimary
                            fullWidth
                            disabled={isSubmitting}
                            type='submit'
                            endIcon={<CallMade />}>
                            {'Continuar'}
                        </EfeButtonPrimary>
                    </Box>
                </BottomContent>
            </Form>
        </div>
    );
}

export default InnerFormTerms;
